module.exports = __webpack_public_path__ + "static/media/tour-compl-1.62c7e0bb.png";